module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-ishikawa-lg-15972d4acf7b480b67f1bb63320994f2.png";